import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/apiClient";
import { PageHeader, Card, Loading, PrimaryBtn, GhostBtn, levelColor } from "../components/kit";

const PHASE = {
  TRAIN: "border-[#CCFF00]", PERFORM: "border-white", TEST: "border-[#FF3B30]",
  PRIME: "border-[#A3A3A3]", COMPETE: "border-[#FF3B30]",
};

export default function CalendarPage() {
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [status, setStatus] = useState("loading");
  const [gen, setGen] = useState(false);

  const load = () => api.get("/plan").then((r) => {
    setStatus(r.data.status);
    if (r.data.status === "ready") setPlan(r.data.plan);
  }).catch(() => setStatus("error"));
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setGen(true);
    toast.loading("Building your plan…", { id: "g" });
    try { await api.post("/plan/generate"); toast.success("Ready!", { id: "g" }); await load(); }
    catch { toast.error("Failed", { id: "g" }); } finally { setGen(false); }
  };

  if (status === "loading") return <div className="p-6"><Loading /></div>;

  if (status !== "ready") {
    return (
      <div className="p-6 sm:p-8 max-w-5xl mx-auto">
        <PageHeader eyebrow="Program" title="Calendar" />
        <Card className="p-8 text-center">
          <p className="text-[#A3A3A3] mb-4">{status === "no_tournament" ? "Set a tournament first." : "No plan generated yet."}</p>
          {status === "not_generated"
            ? <PrimaryBtn onClick={generate} disabled={gen} data-testid="cal-generate">{gen ? "Building…" : "Generate Plan"}</PrimaryBtn>
            : <PrimaryBtn onClick={() => navigate("/profile")}>Go to Profile</PrimaryBtn>}
        </Card>
      </div>
    );
  }

  const todayIso = new Date().toISOString().slice(0, 10);

  return (
    <div className="p-5 sm:p-8 max-w-5xl mx-auto">
      <PageHeader eyebrow="Program" title="Calendar"
        right={<GhostBtn onClick={generate} disabled={gen} data-testid="cal-regen">{gen ? "…" : "Regenerate"}</GhostBtn>} />

      {plan.summary && <Card className="p-5 mb-6"><p className="text-sm text-[#A3A3A3]">{plan.summary}</p></Card>}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {plan.days.map((d) => {
          const isToday = d.date === todayIso;
          return (
            <button key={d.date} data-testid={`cal-day-${d.date}`} onClick={() => navigate(`/training/${d.date}`)}
              className={`text-left border-l-2 ${PHASE[d.phase] || "border-[#262626]"} bg-[#141414] border-y border-r border-[#262626] p-4 hover:bg-[#1F1F1F] transition-colors ${isToday ? "ring-1 ring-[#CCFF00]" : ""}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-heading text-xl uppercase">{d.label}</span>
                <span className={`text-[10px] font-bold uppercase border px-2 py-0.5 ${d.is_tournament_day ? levelColor("HIGH") : "border-[#262626] text-[#A3A3A3]"}`}>{d.phase}</span>
              </div>
              <div className="text-sm font-semibold mb-1">{d.is_tournament_day ? "🏁 Tournament Day" : d.title}</div>
              <div className="flex flex-wrap gap-1 mt-2">
                {(d.focus || []).slice(0, 3).map((f) => <span key={f} className="text-[10px] uppercase text-[#CCFF00] border border-[#262626] px-2 py-0.5">{f}</span>)}
              </div>
              {isToday && <div className="text-[10px] font-bold uppercase text-[#CCFF00] mt-3">● Today</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
